import {
  AfterViewInit,
  Component,
  ContentChild,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  Renderer2,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ButtonPanelDirective } from 'src/app/directives/button-panel.directive';
import { RecordButtonsDirective } from 'src/app/directives/record-buttons.directive';
import { DetailsCardItem } from './models/details-card-item.model';
import { BaseData } from './models/base-data.model';
import { DominantHexColors } from './models/dominant-colors.model';
import { ViewMode } from 'src/app/state/user/searches/models/search';
@Component({
  selector: 'app-card-item',
  templateUrl: './card-item.component.html',
  styleUrls: ['./card-item.component.scss'],
})
export class CardItemComponent implements OnChanges, AfterViewInit {
  @ContentChild(ButtonPanelDirective) buttonPanel!: ButtonPanelDirective;
  @ContentChild(RecordButtonsDirective) recordButtons!: RecordButtonsDirective;

  @Output()
  actionNavigate: EventEmitter<void> = new EventEmitter<void>();

  @Input()
  baseData: BaseData;

  @Input()
  issueDate: string;
  @Input()
  percentage: number;
  @Input()
  showPublicationDate: boolean;

  @Input()
  detailsLeft: DetailsCardItem[];
  @Input()
  detailsRight: DetailsCardItem[];

  @Input()
  dominantColors: DominantHexColors;

  @Input()
  viewMode: ViewMode = 'LIST';

  /*
   * This input is necessary for the suggestions component to work correctly
   * because it may not have the record object  */
  @Input()
  canHover = true;

  @ViewChild('cardItemContainer', { static: true }) cardItemContainer: ElementRef;

  constructor(private renderer: Renderer2) {}

  ngAfterViewInit(): void {
    this.addGradientToBackround();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.viewMode) {
      changes.viewMode.currentValue === 'LIST'
        ? this.cardItemContainer?.nativeElement.style.setProperty('--card-initial-padding', '16px')
        : this.cardItemContainer?.nativeElement.style.setProperty(
            '--card-initial-padding',
            'var(--card-type1-initial-padding)'
          );
    }
  }

  openItemDetail(event: Event) {
    if (event instanceof KeyboardEvent) {
      if (event.target !== event.currentTarget) {
        return;
      }
    }

    this.actionNavigate.emit();
  }

  searchByAuthor(author: string) {
    return { query: `author:"${author}"` };
  }

  private addGradientToBackround() {
    if (this.dominantColors?.showGradient) {
      const buildDominantRGB: string = 'rgba(' + this.dominantColors.dominant + ')';
      const buildSecondaryRGB: string = 'rgba(' + this.dominantColors.secondary + ')';
      this.renderer?.setStyle(
        this.cardItemContainer?.nativeElement,
        'background-image',
        'linear-gradient(to bottom, ' +
          'hsla(var(--primary-background),.9) ,' +
          'hsla(var(--primary-background),.7) 70%,' +
          'hsla(var(--primary-background),.4)), ' +
          'linear-gradient(to right, ' +
          buildDominantRGB +
          ', ' +
          buildDominantRGB +
          ' 33%, ' +
          buildSecondaryRGB +
          ')'
      );
    }
  }
}
